import React from "react";
import { Div } from "components/Base";
import { connect } from "react-redux";

import { noop } from "utils/General";
import { getActiveAccount, getIsEventAdmin } from "../selectors";

import { eventDetails as getEventDetails } from "redux/modules/portal/selectors";

import MenuItem from "./MenuItem";

const decorate = connect(state => ({
  eventData: getEventDetails(state),
  activeAccount: getActiveAccount(state),
  isEventAdmin: getIsEventAdmin(state)
}));

const Body = ({
  eventData = {},
  handleClose = noop,
  setOpenSwitchPortals = noop,
  isEventAdmin
}) => {
  return (
    <Div display="column" width={1} pb={4}>
      <MenuItem
        leftIcon={"pages"}
        onClick={() => {
          setOpenSwitchPortals(true);
        }}
        rightIcon={"chevron_right"}
      >
        Switch Portals
      </MenuItem>

      {isEventAdmin ? (
        <MenuItem
          leftIcon={"manage_accounts"}
          onClick={() => {
            window.location = `/event-light/${eventData.id}/dashboard`;
            handleClose();
          }}
        >
          Back to Admin Mode
        </MenuItem>
      ) : null}

      <Div
        style={{
          alignSelf: "stretch",
          height: "1px",
          background: "#e7e6ea"
        }}
        width={1}
      />
      <MenuItem
        leftIcon={"logout"}
        onClick={() => {
          window.location = `/logout?returnTo=/portal-login/${eventData.slug}/${eventData.uuid}`;
          handleClose();
        }}
      >
        Logout
      </MenuItem>
    </Div>
  );
};

export default decorate(Body);
